import React, { useState } from "react";
import { Box, IconButton, Tooltip } from "@mui/material";
import BasicDatatable from "./Common/BasicDatatable";
import LinkedIn from "../assets/contacts/linkedinicon.svg";
import SalesforceIcon from "../assets/salesforce.svg";
import { getSentimentColor } from "../utils/utils";


interface KaratContact {
  profileOrgId: string;
  firstName: string;
  lastName: string;
  email: string;
  accounts: string;
  isActive: string;
  designation: string;
  sentiment?: string;
  onNameClick?: (email: string, name: string, id: string) => void;
}

interface KaratContactsTableProps {
  data: KaratContact[];
  onNameClick?: (contact: KaratContact) => void;
}

const KaratContactsTable: React.FC<KaratContactsTableProps> = ({
  data,
  onNameClick,
}) => {
  const [rows] = useState(
    data.map((item) => ({
      ...item,
      userName: `${item.firstName ?? ""} ${item.lastName ?? ""}`.trim(),
      handleClick: () => onNameClick && onNameClick(item),
    }))
  );

  const columns = [
    {
      accessorKey: "userName",
      header: "Prospect Name",
      enableSorting: false,
      Cell: ({ row }: any) => (
        <Box
          sx={{
            textDecoration: "underline",
            color: "#1976d2",
            cursor: "pointer",
          }}
          onClick={row.original.handleClick}
        >
          {row.original.userName}
        </Box>
      ),
    },
    {
      accessorKey: "designation",
      header: "Prospect Designation",
      enableSorting: false,
    },
    {
      accessorKey: "email",
      header: "Prospect Email",
      enableSorting: false,
    },
    {
      accessorKey: "isActive",
      header: "Status",
      enableSorting: false,
      size: 100,
      Cell: ({ cell }: any) => <span>{cell.getValue() === "true" ? "Active" : "Inactive"}</span>,
    },
    {
      accessorKey: "sentiment",
      header: "Inclination",
      enableSorting: false,
      Cell: ({ cell } : any) => {
      const sentiment = cell?.getValue();
      const color = getSentimentColor(sentiment);
        if (color) {
            return (
            <Box
                className="meeting-sentiment__box"
                sx={{ backgroundColor: color }}
                title={sentiment}
            />
            );
        }
      }
    },
    {
      id: "actions",
      header: "",
      enableSorting: false,
      Cell: ({ row }: any) => (
        <Box sx={{ display: "flex", gap: 1, justifyContent: "center" }}>
          <Tooltip title="LinkedIn Profile">
            <IconButton
              size="small"
              component="a"
              href={row.original.linkedInUrl}
              target="_blank"
              sx={{
                borderRadius: "6px",
                p: 0.5,
                "&:hover": { backgroundColor: "rgba(0, 119, 181, 0.1)" },
              }}
            >
              <img src={LinkedIn} alt="LinkedIn" width={16} height={16} />
            </IconButton>
          </Tooltip>
          <Tooltip title="Salesforce Record">
            <IconButton
              size="small"
              component="a"
              href={row.original.salesforceUrl}
              target="_blank"
              sx={{
                borderRadius: "6px",
                p: 0.5,
                "&:hover": { backgroundColor: "rgba(0, 149, 218, 0.1)" },
              }}
            >
              <img src={SalesforceIcon} alt="Salesforce" width={16} height={16} />
            </IconButton>
          </Tooltip>
      </Box>
    ),
    }
  ];

  return (
    <Box>
      <BasicDatatable
        columns={columns}
        rows={rows}
        rowCount={rows.length}
        minHeight="50vh"
        isBordervisible={true}
      />
    </Box>
  );
};

export default KaratContactsTable;
